import React, { useContext } from "react";
import SelectInput from "common/SelectInput";
import CheckboxInput from "common/CheckboxInput";
import BqnContext from "common/BqnContext";

const asLabelAndValue = ({ name, bqn }) => ({
  label: `${name}   (BQN ${bqn}}`,
  value: `${name}-${bqn}`,
});
const getOptions = (interfaces, mode, bqnId) => {
  if (mode === "standalone") {
    return interfaces.map(({ name }) => ({ label: name, value: name }));
  }
  if (bqnId === "all") {
    return interfaces.map(asLabelAndValue);
  }
  const filteredInterfaces = interfaces.filter(
    ({ bqn }) => parseFloat(bqn) === parseFloat(bqnId)
  );
  return filteredInterfaces.map(asLabelAndValue);
};

const AskInterface = ({
  end,
  interfaces = [],
  onChange,
  defaultValue = null,
}) => {
  const {
    clusterStatus: { mode },
    bqnId,
  } = useContext(BqnContext);

  return (
    <>
      <SelectInput
        name={`${end}Iface`}
        label={""}
        defaultValue={defaultValue}
        onChange={onChange}
        options={getOptions(interfaces, mode, bqnId)}
        className="input-control align-left"
        icon="location_on"
      />
      <CheckboxInput name={`${end}Pcap`} label="PCAP" />
    </>
  );
};

const interfaceCatAndNumRE = /(.*[a-z])([0-9]+)$/;

const byCategory = (one, another) =>
  one < another ? -1 : another < one ? 1 : 0;

const byId = (one, another) => {
  const [valueOne, valueAnother] = [Number(one), Number(another)];
  return valueOne < valueAnother ? -1 : valueAnother < valueOne ? 1 : 0;
};

const byDeviceName = ({ name: one }, { name: another }) => {
  const [_allOne, catOne, idOne] = one.match(interfaceCatAndNumRE) || [];
  const [_allAnother, catAnother, idAnother] =
    another.match(interfaceCatAndNumRE) || [];
  return byCategory(catOne, catAnother) || byId(idOne, idAnother) || 0;
};

const getFilteredInterfaces = ({ interfaces, mode, bqnId }) => {
  if (mode === "standalone" || bqnId === "all") {
    return interfaces;
  }
  return interfaces.filter(({ bqn }) => parseFloat(bqn) === parseFloat(bqnId));
};

const Fields = ({ onChange, stored = false, interfaces = [] }) => {
  const {
    clusterStatus: { mode },
    bqnId,
  } = useContext(BqnContext);
  const filtered = getFilteredInterfaces({ interfaces, mode, bqnId });
  const [defaultAccIf, defaultInetIf] = filtered.sort(byDeviceName);

  return (
    <>
      <h5>Access interface:</h5>
      <AskInterface
        end="acc"
        interfaces={interfaces}
        onChange={onChange}
        disabled={stored}
        defaultValue={
          mode === "standalone"
            ? defaultAccIf.name
            : `${defaultAccIf.name}-${defaultAccIf.bqn}`
        }
      />
      <h5>Internet interface:</h5>
      <AskInterface
        end="inet"
        interfaces={interfaces}
        onChange={onChange}
        disabled={stored}
        defaultValue={
          mode === "standalone"
            ? defaultAccIf.name
            : `${defaultInetIf.name}-${defaultInetIf.bqn}`
        }
      />
    </>
  );
};
export default Fields;
